<template>
  <div class="outer bg">
    <div class="inner behind"></div>
    <div class="shadow"></div>
    <div class="inner front"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
.bg {
  background: linear-gradient(to bottom, @c7-g 0%, @c7-h 100%);
}
</style>
